<template>
    <div v-if="fornecedor">
        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-4">
                            <az-input 
                                type="label"
                                :label="fornecedor.search">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-secondary" @click="voltar()">
                                            <i class="fa-solid fa-angle-left"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-5">
                            <az-input icon="fas fa-search" v-model="search">
                                <template v-slot:buttonposb>
                                    <importacao service="fornecedor_lista_precos" :parms="{ id_fornecedor: fornecedor.id_fornecedor }" @refresh="load()" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" @click="incluir ()">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                        
                    </div>

                </div>

            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state 
                :msg="'Nenhum preço listado identificado.'" 
                :icon="search ? 'fas fa-search' : 'fa-solid fa-dollar-sign'"
                action="Incluir" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <table class="table table-sm border-0 table-responsive" v-if="classes && classes.length">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in classes" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ classe }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">
                            #{{ dado.id_estoque_item }}
                        </span>

                        <div v-if="dado.js_classes && dado.js_classes.length">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                v-for="(tag, itx) in dado.js_classes" :key="itx">
                                <span class="badge badge-success mr-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>

                        <div v-else class="text-right">
                            <span v-if="dado.dc_preco">
                                {{ $util.formatMoeda(dado.dc_preco, 6, 2) }}
                            </span>
                            <div class="small text-muted" v-if="dado.st_codigo">
                                {{ dado.st_codigo }}
                            </div>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Edição de Preço -->
        <div class="modal fade" id="edicaoListaPrecoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Item {{ item.id_fornecedor_lista_preco ? '#' + item.id_fornecedor_lista_preco : 'Novo' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                 <az-input
                                    label="Item de Estoque"
                                    v-if="!item.item"
                                    placeholder="Selecione o material..."
                                    sizing="sm"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="estoque_items.index"
                                    optionsData="id_estoque_item"
                                    v-model="item.id_estoque_item" />

                                <az-input
                                    v-else
                                    sizing="sm"
                                    label="Item de Estoque"
                                    :edicao="false"
                                    v-model="item.item.search" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input   
                                    sizing="sm"
                                    label="Código do Fornecedor"
                                    v-model="item.st_codigo" />
                            </div>
                            <div class="col col-12 col-md-9">
                                <az-input   
                                    sizing="sm"
                                    label="Descrição do Fornecedor"
                                    v-model="item.st_descricao" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input   
                                    sizing="sm"
                                    label="Preço"
                                    type="money"
                                    :precision="6"
                                    v-model="item.dc_preco" />
                            </div>
                            <div class="col col-12 col-md-9">
                                <az-input   
                                    sizing="sm"
                                    label="Observação"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <az-sub-title title="Classificações" class="mt-3" />
                        <div class="form-row">
                            <div class="col col-12">
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação selecionada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">{{ item.id_fornecedor_lista_preco ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null,
            item: null, 
            search: "", 
            em_edicao: false, 
            viewMode: "A",
            validate: false, 
            impostos: [], 
            saved: true, 
            tipo_pessoa: "T", 
            ver_vencidos: false, 
            fornecedor: "", 
            options_classes: null, 
        }
    },

    props: ['suprimentos'],

    components: { 
        AzInput, 
        Importacao, 
        AzEmptyState,
        AzSubmit,  
        Multiselect, 
        AzSubTitle, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            let hoje = this.$util.hoje();

            return this.dados ? 
                _.orderBy(
                    this.dados.filter (item => { 
                        
                        return ( item.fl_ativo || this.viewMode != 'A' ) && 
                            ( this.tipo_pessoa == 'T' || item.tipo_pessoa == this.tipo_pessoa ) && 
                            ( !this.search || reg.test(JSON.stringify(item)) );
                        
                    })
                    .filter(item => !this.ver_vencidos || item.arquivos.find(arq => arq.dt_validade && arq.dt_validade < hoje)), 'item.search') : [];
                    
        },

        classes() { 
            if ( !this.dados )
                return [];

            return _.orderBy(
                    _.uniq(
                        this.dados.flatMap(item => item.js_classes ? item.js_classes : [])
                    ),
                    item => item.toUpperCase()
                );
        },

        anexos_vencidos: function () { 
            let hoje = this.$util.hoje();

            return this.lista.flatMap(item => item.arquivos ? item.arquivos.filter(item => item.dt_validade && item.dt_validade < hoje) : []);
        }
    },

    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        voltar () { 
            this.fornecedor = null; 
            this.$emit('voltar');
        },

        abrir (fornecedor) { 
            this.fornecedor = _.cloneDeep(fornecedor);
            this.load();

            if ( this.options_classes === null ) { 
                this.$util.load(this, { 
                    service: 'fornecedor_lista_precos', 
                    func: 'tags', 
                    loadTo: res => { 
                        this.options_classes = res;
                    }
                });
            }
        },

        editar (item) { 
            this.item = null; 

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);

                this.$nextTick(() => { 
                    $('#edicaoListaPrecoModal').modal('show');
                });
            });
        },

        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        incluir () { 
            this.item = null; 

            this.$nextTick(() => { 
                this.item = { 
                    id_fornecedor: this.fornecedor.id_fornecedor, 
                    st_codigo: "", 
                    st_descricao: "", 
                    dc_preco: 0, 
                    fl_ativo: true, 
                    id_estoque_item: "", 
                    item: null, 
                    st_observacoes: "", 
                    js_classes: [], 
                };

                this.$nextTick(() => { 
                    $('#edicaoListaPrecoModal').modal('show');
                });
            });
        },

        atualizar () { 
            this.$util.atualizar (this, { 
                service: 'fornecedor_lista_precos',
                dados: this.item, 
                modal: 'edicaoListaPrecoModal', 
                reload: true, 
            });
        },

        toggle (item) { 
            this.$util.toggle (this, { 
                service: 'fornecedor_lista_precos', 
                dados: { ...item }, 
            })
        },

        load () { 
            this.$util.load(this, { 
                service: 'fornecedor_lista_precos',
                parms: { 
                    cadastro: true, 
                }
            });
        }
    },

    mounted () { 
       //
    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },

}
</script>